/*
有效性判断     
*/
function isempty(str){
    if(str === null || typeof str === "undefined" || str.length <= 0) return true;
    const reg = /(^\s+)|(\s+$)|\s+/g;
    return reg.test(str);
}


export default isempty